/** Matches public/index.html defaults; used when leaving blog routes. */
export const DEFAULT_DOCUMENT_TITLE =
  'Substyle | Animated Subtitles in Premiere Pro — 14 Languages';

export const DEFAULT_META_DESCRIPTION =
  'Create animated subtitles directly inside Premiere Pro with Substyle. Supports 14 languages including Ukrainian, Spanish, German, and more. Word-level timing, customizable styles, full timeline integration.';
